var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.value, "max-width": "960px", scrollable: "" },
      on: { input: _vm.onDialogInput },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "d-flex align-center" },
            [
              _c("v-icon", { attrs: { color: "primary" } }, [
                _vm._v("mdi-creation"),
              ]),
              _c("span", { staticClass: "pl-2" }, [_vm._v("AI Insights")]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", "aria-label": "Close" },
                  on: { click: _vm.close },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _vm.reportSubtitle
            ? _c("v-card-subtitle", { staticClass: "pb-2" }, [
                _vm._v(_vm._s(_vm.reportSubtitle)),
              ])
            : _vm._e(),
          _c("v-divider"),
          _c(
            "v-card-text",
            { staticClass: "pt-4 ai-insights-body" },
            [
              _c(
                "v-alert",
                {
                  staticClass: "mb-4",
                  attrs: { type: "warning", dense: "", text: "" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "font-weight-bold text-body-2 mb-1" },
                    [_vm._v("AI-Generated Content Notice")]
                  ),
                  _c("div", { staticClass: "text-body-2" }, [
                    _vm._v(_vm._s(_vm.disclaimer)),
                  ]),
                ]
              ),
              _vm.loading
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-column align-center justify-center py-12",
                      attrs: { "data-test": "ai-insights-loading" },
                    },
                    [
                      _c("v-progress-circular", {
                        staticClass: "mb-4",
                        attrs: {
                          indeterminate: "",
                          color: "primary",
                          size: "48",
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "text-h6 grey--text text--darken-2" },
                        [_vm._v("Analyzing batch…")]
                      ),
                      _c("div", { staticClass: "text-body-2 grey--text" }, [
                        _vm._v("This usually takes about a minute."),
                      ]),
                    ],
                    1
                  )
                : _vm.error
                ? _c(
                    "v-alert",
                    {
                      attrs: {
                        type: "error",
                        dense: "",
                        text: "",
                        "data-test": "ai-insights-error",
                      },
                    },
                    [
                      _c("div", { staticClass: "font-weight-bold" }, [
                        _vm._v("Error generating insights"),
                      ]),
                      _c("div", { staticClass: "text-body-2" }, [
                        _vm._v(_vm._s(_vm.error)),
                      ]),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mt-2",
                          attrs: { small: "", outlined: "", color: "error" },
                          on: { click: _vm.retry },
                        },
                        [_vm._v("Try again")]
                      ),
                    ],
                    1
                  )
                : _vm.result && _vm.result.no_data
                ? _c(
                    "v-alert",
                    {
                      attrs: {
                        type: "info",
                        dense: "",
                        text: "",
                        "data-test": "ai-insights-no-data",
                      },
                    },
                    [_vm._v(" This batch has no rows to analyze. ")]
                  )
                : _vm.result
                ? _c(
                    "div",
                    {
                      ref: "content",
                      staticClass: "ai-insights-content",
                      attrs: { "data-test": "ai-insights-content" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "ai-insights-stats" },
                        _vm._l(_vm.statTiles, function (tile) {
                          return _c(
                            "div",
                            {
                              key: tile.label,
                              staticClass: "ai-insights-stat",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "ai-insights-stat-label" },
                                [_vm._v(_vm._s(tile.label))]
                              ),
                              _c(
                                "div",
                                { staticClass: "ai-insights-stat-value" },
                                [_vm._v(_vm._s(tile.value))]
                              ),
                              tile.detail
                                ? _c(
                                    "div",
                                    { staticClass: "ai-insights-stat-detail" },
                                    [_vm._v(_vm._s(tile.detail))]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      ),
                      _c("p", { staticClass: "ai-insights-meta" }, [
                        _vm.generatedAt
                          ? _c("span", [
                              _vm._v(
                                "Generated " + _vm._s(_vm.generatedAt) + "."
                              ),
                            ])
                          : _vm._e(),
                        _vm.rulesAsOf
                          ? _c("span", [
                              _vm._v(
                                " Rules reflect this batch as last processed on " +
                                  _vm._s(_vm.rulesAsOf) +
                                  "."
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _c("div", {
                        staticClass: "ai-insights-report",
                        domProps: { innerHTML: _vm._s(_vm.renderedInsights) },
                      }),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            { staticClass: "pa-3" },
            [
              _vm.showCost && _vm.usageText
                ? _c(
                    "span",
                    {
                      staticClass: "text-caption grey--text text--darken-1",
                      attrs: { "data-test": "ai-insights-cost" },
                    },
                    [_vm._v(" " + _vm._s(_vm.usageText) + " ")]
                  )
                : _vm._e(),
              _c("v-spacer"),
              _vm.canExport
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        loading: _vm.exporting,
                        "data-test": "ai-insights-export",
                      },
                      on: { click: _vm.exportPdf },
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-file-pdf-box"),
                      ]),
                      _vm._v(" Export PDF "),
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-btn", { attrs: { text: "" }, on: { click: _vm.close } }, [
                _vm._v("Close"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }